/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { Link } from "react-scroll";

import Menu from "./Menu";

const styles = css`
  padding: 20px;
  height: 100px;
  position: fixed;
  text-align: center;
  width: 100%;
  box-shadow: 10px 10px 10px rgba(010, 010, 010, 0.3);
  border-bottom: 1px #000 solid;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);

  img {
    cursor: pointer;
  }
`;

const Header = () => (
  <header css={styles}>
    <Link
      to="home"
      spy={true}
      smooth={true}
      duration={500}
      containerId="main"
      offset={-140}
      isDynamic
    >
      <img src="/assets/logo.png" alt="Andesh Logo" />
    </Link>
    <Menu />
  </header>
);

export default Header;
